import { NSCard } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import React from 'react';
import { useParams } from 'react-router-dom';
import DocumentPreview from 'views/DocumentLibrary/components/DocumentLibrarySlideout/DocumentPreview';
import DropzoneCard from 'views/DocumentLibrary/components/DropzoneCard/DropzoneCard';
import { PREVIEW_MIN_HEIGHT } from 'views/ProFormaUpload/constants';

export interface IFileContainer {
    previewUrl: string | null;
    isPreviewLoading: boolean;
    handleFileUpload: (event: React.DragEvent<HTMLElement> |
        React.ChangeEvent<HTMLInputElement>, dropLocation: string) => Promise<File[]>;
}

const FileContainer = ({ previewUrl, isPreviewLoading, handleFileUpload }: IFileContainer) => {
    const { proFormaId } = useParams();

    const handleOpenDocument = () => {
        if (previewUrl) {
            window.open(previewUrl, '_blank');
        }
    };

    return (
        <div className="w-50 mr-4">
            <RenderIf isTrue={!previewUrl && !proFormaId} isLoading={isPreviewLoading}>
                <div className="h-100">
                    <DropzoneCard
                        getFilesFromEvent={handleFileUpload}
                        maxFiles={1}
                    />
                </div>
            </RenderIf>

            <RenderIf isTrue={previewUrl}>
                <NSCard>
                    <DocumentPreview
                        uri={previewUrl!}
                        format="xlsx"
                        handleOpenDocument={handleOpenDocument}
                        minHeight={PREVIEW_MIN_HEIGHT}
                    />
                </NSCard>
            </RenderIf>
        </div>
    );
};

export default FileContainer;
